export const deleteFunctionalityIndicatorsService = (fetch) => async (id) => {
  try {
    const response = await fetch({
      method: "delete",
      url: `/api/v1/funcionamiento/indicadores/${id}`,
    });
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
